import React from 'react';
import { Link } from 'react-router-dom';
import {
    Home, Users, Database,
    Bell, Search, HelpCircle,
    MessageSquare, ChevronDown, BarChart2, PieChart,
    Activity, TrendingUp, Calendar, Download,
    BarChart, LineChart, Zap, PlusCircle
} from 'lucide-react';


const LumiLogicDashboard = () => {
    return (
        <div className="flex flex-col h-screen bg-gray-100">
            {/* Top Navigation Bar */}
            <header className="bg-gray-800 shadow-sm py-3 px-6 flex justify-between items-center">
                <div className="flex items-center space-x-10">
                    <div className="flex items-center">
                        <img src="/logo192.png" alt="LumiLogic Logo" className="w-auto h-8 mr-2" />
                        <span className="font-bold text-xl text-teal-300">LumiLogic</span>
                    </div>
                    <div className="hidden md:flex space-x-6">
                        <button className="nav-item px-3 py-1 text-sm font-medium rounded flex items-center text-teal-500 hover:bg-gray-700">
                            <Home size={16} className="mr-2" />
                            Dashboard
                        </button>
                        <Link to="/data-source" className="nav-item px-3 py-1 text-sm font-medium rounded flex items-center text-teal-500 hover:bg-gray-700">
                            <Database size={16} className="mr-2" />
                            Data Sources
                        </Link>
                        <button className="nav-item px-3 py-1 text-sm font-medium rounded flex items-center text-teal-500 hover:bg-gray-700">
                            <BarChart2 size={16} className="mr-2" />
                            Reports
                        </button>
                        <button className="nav-item px-3 py-1 text-sm font-medium rounded flex items-center text-teal-500 hover:bg-gray-700">
                            <Users size={16} className="mr-2" />
                            Team
                        </button>
                    </div>
                </div>
                <div className="flex items-center space-x-4">
                    <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-full relative">
                        <Bell size={20} />
                        <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
                    </button>
                    <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-full">
                        <HelpCircle size={20} />
                    </button>
                    <div className="flex items-center cursor-pointer">
                        <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center text-white font-medium">
                            KF
                        </div>
                        <ChevronDown size={16} className="ml-2 text-gray-500" />
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <div className="flex-1 overflow-auto p-6">
                {/* Welcome & Quick Stats */}
                <div className="mb-8">
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800">Welcome back, Katina!</h1>
                            <p className="text-gray-600">Here's what's happening with your data today</p>
                        </div>
                        <div className="flex space-x-3">
                            <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 flex items-center bg-white hover:bg-gray-50">
                                <Calendar size={16} className="mr-2" />
                                Last 30 days
                                <ChevronDown size={16} className="ml-2" />
                            </button>
                            <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 flex items-center bg-white hover:bg-gray-50">
                                <Download size={16} className="mr-2" />
                                Export
                            </button>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                            <div className="flex justify-between items-start">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Total Visitors</p>
                                    <h3 className="text-2xl font-bold mt-1">24,582</h3>
                                    <div className="flex items-center mt-2">
                    <span className="text-green-500 flex items-center text-sm">
                      <TrendingUp size={14} className="mr-1" />
                      12.5%
                    </span>
                                        <span className="text-xs text-gray-500 ml-2">vs last period</span>
                                    </div>
                                </div>
                                <div className="p-2 bg-blue-50 rounded-md">
                                    <Activity size={20} className="text-blue-600" />
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                            <div className="flex justify-between items-start">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Conversion Rate</p>
                                    <h3 className="text-2xl font-bold mt-1">3.6%</h3>
                                    <div className="flex items-center mt-2">
                    <span className="text-red-500 flex items-center text-sm">
                      <TrendingUp size={14} className="mr-1 transform rotate-180" />
                      2.1%
                    </span>
                                        <span className="text-xs text-gray-500 ml-2">vs last period</span>
                                    </div>
                                </div>
                                <div className="p-2 bg-purple-50 rounded-md">
                                    <PieChart size={20} className="text-purple-600" />
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                            <div className="flex justify-between items-start">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Revenue</p>
                                    <h3 className="text-2xl font-bold mt-1">$12,489</h3>
                                    <div className="flex items-center mt-2">
                    <span className="text-green-500 flex items-center text-sm">
                      <TrendingUp size={14} className="mr-1" />
                      8.2%
                    </span>
                                        <span className="text-xs text-gray-500 ml-2">vs last period</span>
                                    </div>
                                </div>
                                <div className="p-2 bg-green-50 rounded-md">
                                    <BarChart size={20} className="text-green-600" />
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                            <div className="flex justify-between items-start">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Social Engagement</p>
                                    <h3 className="text-2xl font-bold mt-1">15.3k</h3>
                                    <div className="flex items-center mt-2">
                    <span className="text-green-500 flex items-center text-sm">
                      <TrendingUp size={14} className="mr-1" />
                      24.5%
                    </span>
                                        <span className="text-xs text-gray-500 ml-2">vs last period</span>
                                    </div>
                                </div>
                                <div className="p-2 bg-pink-50 rounded-md">
                                    <MessageSquare size={20} className="text-pink-600" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* GlowSight AI Section */}
                <div className="mb-8 bg-gray-800 rounded-xl p-6 border border-gray-700">
                    <div className="flex items-center mb-4">
                        <Zap size={24} className="text-blue-200 mr-2" />
                        <h2 className="text-xl font-bold text-white">GlowSight AI</h2>
                    </div>
                    <p className="text-gray-200 mb-4">Ask questions about your data in plain language</p>
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Example: How did our Facebook engagement change compared to last month?"
                            className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                        />
                        <Search size={20} className="absolute right-4 top-3 text-gray-400" />
                    </div>
                    <div className="mt-4 flex flex-wrap gap-2">
                        <button className="px-3 py-1 bg-white text-sm rounded-full border border-gray-300 text-gray-700 hover:bg-gray-50">
                            What's driving our revenue growth?
                        </button>
                        <button className="px-3 py-1 bg-white text-sm rounded-full border border-gray-300 text-gray-700 hover:bg-gray-50">
                            Show me conversion trends by channel
                        </button>
                        <button className="px-3 py-1 bg-white text-sm rounded-full border border-gray-300 text-gray-700 hover:bg-gray-50">
                            Compare this month to last year
                        </button>
                    </div>
                </div>

                {/* Dashboard Templates */}
                <div className="mb-8">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-bold text-gray-800">Your Dashboards</h2>
                        <button className="px-4 py-2 bg-blue-600 text-white rounded-md flex items-center hover:bg-blue-700">
                            <PlusCircle size={16} className="mr-2" />
                            New Dashboard
                        </button>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                            <div className="h-40 bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center">
                                <BarChart2 size={48} className="text-white opacity-50" />
                            </div>
                            <div className="p-4">
                                <h3 className="font-medium text-gray-800">Business Overview</h3>
                                <p className="text-gray-500 text-sm mt-1">Key metrics and performance indicators</p>
                                <div className="mt-4 flex justify-between items-center">
                                    <span className="text-xs font-medium px-2 py-1 bg-blue-100 text-blue-800 rounded-full">Default Template</span>
                                    <button className="text-blue-600 text-sm font-medium">View</button>
                                </div>
                            </div>
                        </div>

                        <Link to="/dashboard-detail" className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden block hover:shadow-md transition-shadow">
                            <div className="h-40 bg-gradient-to-r from-purple-400 to-purple-600 flex items-center justify-center">
                                <LineChart size={48} className="text-white opacity-50" />
                            </div>
                            <div className="p-4">
                                <h3 className="font-medium text-gray-800">Marketing Performance</h3>
                                <p className="text-gray-500 text-sm mt-1">Campaign results and channel analysis</p>
                                <div className="mt-4 flex justify-between items-center">
                                    <span className="text-xs font-medium px-2 py-1 bg-purple-100 text-purple-800 rounded-full">Custom</span>
                                    <span className="text-blue-600 text-sm font-medium">View</span>
                                </div>
                            </div>
                        </Link>

                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                            <div className="h-40 bg-gradient-to-r from-green-400 to-green-600 flex items-center justify-center">
                                <PieChart size={48} className="text-white opacity-50" />
                            </div>
                            <div className="p-4">
                                <h3 className="font-medium text-gray-800">Financial Insights</h3>
                                <p className="text-gray-500 text-sm mt-1">Revenue breakdown and financial metrics</p>
                                <div className="mt-4 flex justify-between items-center">
                                    <span className="text-xs font-medium px-2 py-1 bg-green-100 text-green-800 rounded-full">Revenue Template</span>
                                    <button className="text-blue-600 text-sm font-medium">View</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Data Sources */}
                <div className="mb-8">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-bold text-gray-800">Connected Data Sources</h2>
                        <Link to="/data-source" className="text-blue-600 font-medium flex items-center">
                            <PlusCircle size={16} className="mr-1" />
                            Add Source
                        </Link>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                        <div className="p-6">
                            <div className="space-y-4">
                                <div className="flex items-center justify-between py-2">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 bg-blue-100 rounded-md flex items-center justify-center mr-4">
                                            <div className="w-6 h-6 bg-blue-600 rounded-sm"></div>
                                        </div>
                                        <div>
                                            <h3 className="font-medium">Facebook Insights</h3>
                                            <p className="text-xs text-gray-500">Last updated: 2 hours ago</p>
                                        </div>
                                    </div>
                                    <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">Active</span>
                                </div>

                                <div className="flex items-center justify-between py-2">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 bg-red-100 rounded-md flex items-center justify-center mr-4">
                                            <div className="w-6 h-6 bg-red-600 rounded-sm"></div>
                                        </div>
                                        <div>
                                            <h3 className="font-medium">Google Analytics 4</h3>
                                            <p className="text-xs text-gray-500">Last updated: 1 hour ago</p>
                                        </div>
                                    </div>
                                    <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">Active</span>
                                </div>

                                <div className="flex items-center justify-between py-2">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 bg-blue-100 rounded-md flex items-center justify-center mr-4">
                                            <div className="w-6 h-6 bg-blue-800 rounded-sm"></div>
                                        </div>
                                        <div>
                                            <h3 className="font-medium">LinkedIn Ads</h3>
                                            <p className="text-xs text-gray-500">Last updated: 3 hours ago</p>
                                        </div>
                                    </div>
                                    <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">Needs Attention</span>
                                </div>

                                <div className="flex items-center justify-between py-2">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 bg-green-100 rounded-md flex items-center justify-center mr-4">
                                            <div className="w-6 h-6 bg-green-600 rounded-sm"></div>
                                        </div>
                                        <div>
                                            <h3 className="font-medium">QuickBooks</h3>
                                            <p className="text-xs text-gray-500">Last updated: 6 hours ago</p>
                                        </div>
                                    </div>
                                    <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">Active</span>
                                </div>
                            </div>

                            <div className="mt-4 text-center">
                                <Link to="/data-source" className="text-blue-600 text-sm font-medium">View All Sources</Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Recent Reports */}
                <div>
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-bold text-gray-800">Recent Reports</h2>
                        <button className="text-blue-600 font-medium">View All</button>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Report Name
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Type
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Last Generated
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Schedule
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Actions
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                <tr>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm font-medium text-gray-900">Weekly Performance Summary</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
                        Dashboard Export
                      </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        May 9, 2025
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        Weekly (Monday)
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                        <button className="text-blue-600 hover:text-blue-900 mr-3">View</button>
                                        <button className="text-gray-600 hover:text-gray-900">Edit</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm font-medium text-gray-900">Monthly Marketing Results</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-800">
                        Custom Report
                      </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        April 30, 2025
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        Monthly (1st)
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                        <button className="text-blue-600 hover:text-blue-900 mr-3">View</button>
                                        <button className="text-gray-600 hover:text-gray-900">Edit</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm font-medium text-gray-900">Q1 Financial Review</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">
                        Executive Report
                      </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        April 15, 2025
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        Quarterly
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                        <button className="text-blue-600 hover:text-blue-900 mr-3">View</button>
                                        <button className="text-gray-600 hover:text-gray-900">Edit</button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LumiLogicDashboard;